module.exports = __webpack_public_path__ + "assets/img/2.29291d77.png";